export default __webpack_public_path__ + "static/media/app-store-black-bg.png";